import { ShieldAlert } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/context/I18nContext";
import { Button } from "@/components/ui/button";
import { OPS } from "@/constants/testIds";

export default function NoAccessPage() {
    const { logout } = useAuth();
    const { t } = useI18n();
    return (
        <div
            data-testid={OPS.error.noAccess}
            className="flex flex-col items-center justify-center gap-4 py-24 text-center"
        >
            <span className="flex h-16 w-16 items-center justify-center rounded-2xl bg-[color:rgba(186,217,235,0.5)]">
                <ShieldAlert className="h-8 w-8 text-[color:var(--brand-brown)]" />
            </span>
            <h2 className="text-xl font-bold text-[color:var(--ink)]">{t("no_access_title")}</h2>
            <p className="max-w-md text-sm text-[color:var(--ink-muted)]">{t("no_access_desc")}</p>
            <Button variant="outline" onClick={logout}>
                {t("logout")}
            </Button>
        </div>
    );
}
